export enum StatusEnum {
  ACTIVE = "ACTIVE",
  CLEARED = "CLEARED",
  ACKNOWLEDGED = "ACKNOWLEDGED",
}
